import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { DiamondLoader } from './DiamondLoader';
import { Lock } from 'lucide-react';

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <DiamondLoader size="lg" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (adminOnly && user.role !== 'admin') {
    return <Navigate to="/dashboard" />;
  }

  if (user.status === 'pending' && user.role !== 'admin') {
    return (
      <div className="min-h-screen flex items-center justify-center px-6">
        <div className="max-w-md text-center space-y-6">
          <div className="w-20 h-20 bg-primary/10 border border-primary mx-auto flex items-center justify-center">
            <Lock className="text-primary" size={40} />
          </div>
          <h1 className="font-heading text-3xl font-semibold">Account Pending Approval</h1>
          <p className="text-muted-foreground">
            Your account is currently under review. You'll receive an email once your account has been approved by our team.
          </p>
        </div>
      </div>
    );
  }

  return children;
};